module.exports = __webpack_public_path__ + "static/media/50k.05ddef5b.webp";